require('../../vant-css/base.css');


// WEBPACK FOOTER //
// ./node_modules/vant/lib/loading/style/index.js